<template>
  <div v-if="isBlockLoading" class="flex items-center justify-center">
    <Loader color="#64748B" width="50px" height="50px" />
  </div>
  <template v-else>
    <!-- <button v-if="searchData && Array.isArray(searchData.result)
          && (searchData.result.length > 1) && ((lastPath === '/block') || (lastPath === '/search-result'))"
      class="bg-white uppercase border-2 border-red text-blue-dark px-7 py-0.5 md:m-0 mb-10" style="border-radius: 3px"
      @click="goBack">
      Back
    </button> -->
    <div v-if="blockDetails && Object.keys(blockDetails).length > 0" class="mb-[30px]">
      <div class="text-left mt-14">
        <div class="flex items-start justify-start flex-wrap gap-[88px]">
          <div class="flex flex-col justify-start">
            <Paragraph class="font-inter-regular text-[#3B82F6] text-[25px] leading-[30px]" text="block height" />
            <Paragraph class="font-inter-regular text-[#3B82F6] text-[25px] leading-[65px] break-all w-full text-left"
              :text="`#${blockDetails.block}`" />
          </div>
          <div class="flex flex-col justify-start">
            <Paragraph class="font-inter-regular text-[#2A4067] text-[25px] leading-[29px]" text="chain name" />
            <router-link
              v-if="blockDetails.chainName && blockDetails.chainNumber !== undefined && blockDetails.chainNumber !== null"
              :to="{ name: 'chain', params: { chainNumber: blockDetails.chainNumber } }"
              class="font-inter-regular text-[#2A4067] text-[25px] leading-[65px] break-all w-full text-left"
            >
              {{ blockDetails.chainName }}
            </router-link>
            <Paragraph
              v-else
              class="font-inter-regular text-[#2A4067] text-[25px] leading-[65px] break-all w-full text-left"
              :text="blockDetails.chainName"
            />
          </div>
        </div>
      </div>
      <div class="mt-[66px]">
        <Paragraph class="font-inter-regular text-[#2A4067] text-[25px] leading-[30px] mb-[17px]" text="Overview" />
        <div class="max-w-max flex gap-[93px] bg-white rounded-[12px] px-[22px] py-[5px] my-[20px]">
          <div v-if="blockDetails && Object.keys(blockDetails).length > 0" class="flex-grow max-w-[850px]">
            <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px] min-w-[120px]"
                text="Transactions" />
              <p class="font-jost-regular text-[#2A4067] text-base leading-[21px]">
                {{ blockDetails.transactionsIncluded }}
              </p>
            </div>
            <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px] min-w-[120px]"
                text="Merkle Root" />
              <p class="font-jost-regular text-[#2A4067] text-base leading-[21px]">
                {{ blockDetails.merkleRoot }}
              </p>
            </div>
            <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px] min-w-[120px]"
                text="Chain Number" />
              <router-link
                v-if="blockDetails.chainNumber !== undefined && blockDetails.chainNumber !== null"
                class="font-jost-regular text-blue-light text-base leading-[21px] cursor-pointer"
                :to="{ name: 'chain', params: { chainNumber: blockDetails.chainNumber } }"
              >
                #{{ blockDetails.chainNumber }}
              </router-link>
              <p v-else class="font-jost-regular text-[#2A4067] text-base leading-[21px]">
                {{ blockDetails.chainNumber }}
              </p>
            </div>
            <!-- <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px] min-w-[120px]"
                text="Hub Number" />
              <p class="font-jost-regular text-[#2A4067] text-base leading-[21px]">
                {{ blockDetails.hubNumber }}
              </p>
            </div>
            <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px] min-w-[120px]"
                text="Relay Number" />
                <p class="font-jost-regular text-[#2A4067] text-base leading-[21px]">
                  {{ blockDetails.relayNumber }}
              </p>
            </div> -->
            <div class="flex gap-[105px] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px] min-w-[120px]"
                text="Timestamp" />
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px]"
                :text="getTxCreationDateUtc(blockDetails.createdAt)" />
            </div>
            <!-- <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px] min-w-[91px]"
                text="Merkle Root" />
                <div class="flex gap-[10px] items-center">
                  <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px]"
                    text="dc3934d58cfbb0b63ec0f0df8e82c90df3621f2527e6e66a38b4edf3e9692439" />
                  <CopyIcon :isActive="checkIfIsEqual('dc3934d58cfbb0b63ec0f0df8e82c90df3621f2527e6e66a38b4edf3e9692439')" 
                    @click="copy('dc3934d58cfbb0b63ec0f0df8e82c90df3621f2527e6e66a38b4edf3e9692439')"
                    title="Copy hash"
                    class="min-w-[16px] h-[19px] inline-block cursor-pointer align-text-top ml-[10px]" />
                </div>
             
            </div> -->
<!--            
            <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px] min-w-[91px]"
                text="Hub Number" />
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px]"
                :text="11" />
            </div>
            <div class="flex gap-[105px] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px] min-w-[91px]"
                text="Relay number" />
              <Paragraph class="font-jost-regular text-[#2A4067] text-base leading-[21px]"
                :text="3" />
            </div> -->
          </div>
        </div>
      </div>
      <div class="mt-[66px]">
        <Paragraph class="font-inter-regular text-[#2A4067] text-[25px] leading-[30px] mt-[82px] mb-[10px]"
          text="Transactions for this block" />
        <div v-if="isTransactionsLoading" class="flex items-center justify-center py-6">
          <Loader color="#64748B" width="30px" height="30px" />
        </div>
        <SearchableTable 
          :transactions="blockTransactions || []" 
          :copied="copied"
          :initialFilters="searchableTableInitialFilters"
          @copied="handleCopied"
          @filtersChanged="handleFiltersChanged"
        />
        <div class="flex justify-end px-[25px]">
          <pagination-component :items="blockTransactions.totalCount || 0" :initialPage="getInitialPage()"
            @changePage="setFoundResult" class="float-left" />
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="blockNumber">
        <Paragraph class="text-left text-[25px] text-blue-dark font-jost-regular leading-[36px]"
          text="There are 0 transactions for this block" />
        <HeadingComponent :text="blockNumber"
          class="text-left text-[33px] font-jost-regular text-blue-light break-all leading-[47px]" />
      </div>
    </div>
  </template>
</template>

<script>
import "vue-json-pretty/lib/styles.css";
import Paragraph from "@/components/web/ParagraphComponent";
import PaginationComponent from "@/components/common/PaginationComponent";
import api from '@/helpers/api';
import string from '@/helpers/string';
import HeadingComponent from '@/components/web/HeadingComponent';
import Loader from '@/components/common/Loader.vue';
import SearchableTable from '@/components/common/SearchableTable.vue';
import { getLinkToAccount } from '@/helpers/common';

import { maxTableRows } from '@/utils/pagination';
import moment from 'moment';

const TRANSACTION_TYPE_VALUES = ['attestCommit', 'coin', 'proxyCreate', 'nftMint'];

export default {
  name: "BlockComponent",
  props: {
    blockNumber: {
      required: true
    }
  },
  components: {
    // CopyIcon,
    Paragraph,
    PaginationComponent,
    HeadingComponent,
    Loader,
    SearchableTable
  },
  data: () => {
    return {
      blockDetails: null,
      blockTransactions: {
        items: [],
        totalCount: 0
      },
      copied: '',
      isBlockLoading: false,
      isTransactionsLoading: false,
      initialPage: 1,
      pageSize: maxTableRows,
      limitPerPage: maxTableRows,
      blockData: {},
      transactionCount: 0,
      lastPath: null,
      maxTableRows,
      colsCount: 6,
      transactionFilters: {
        type: [...TRANSACTION_TYPE_VALUES],
        minBlock: undefined,
        maxBlock: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        from: undefined,
        to: undefined,
        status: ['valid', 'invalid'],
      },
    }
  },
  computed: {
    chainNumber() {
      const routeChain = this.$route.params.chainNumber || this.$route.params.chain;
      return routeChain ? parseInt(routeChain, 10) : null;
    },
    searchableTableInitialFilters() {
      const parsedBlock = Number(this.blockNumber);
      if (Number.isNaN(parsedBlock) || parsedBlock <= 0) {
        return {};
      }

      return {
        blockMin: parsedBlock,
        blockMax: parsedBlock,
      };
    },
  },
  watch: {
    blockNumber() {
      // Reset when block changes and fetch with default type filters
      this.blockTransactions = {
        totalCount: 0,
        items: []
      };
      this.getBlockDetails();
    },
    chainNumber(newChainNumber, oldChainNumber) {
      if (newChainNumber === oldChainNumber) {
        return;
      }

      this.getBlockDetails();
    }
  },
  created() {
    this.getBlockDetails();
    this.lastPath = this.$router.options.history.state.back;
  },
  methods: {
    initializeBlockFilters() {
      const parsedBlock = Number(this.blockNumber);
      if (!Number.isNaN(parsedBlock) && parsedBlock > 0) {
        this.transactionFilters = {
          type: [...TRANSACTION_TYPE_VALUES],
          minBlock: parsedBlock,
          maxBlock: parsedBlock,
          dateFrom: undefined,
          dateTo: undefined,
          from: undefined,
          to: undefined,
          status: ['valid', 'invalid'],
        };
      }
    },
    fetchTransactions(skip) {
      const parsedBlock = Number(this.blockNumber);
      const hasValidChain = Number.isInteger(this.chainNumber) && this.chainNumber > 0;
      const hasValidBlock = !Number.isNaN(parsedBlock) && parsedBlock > 0;

      if (!hasValidChain || !hasValidBlock) {
        this.isTransactionsLoading = false;
        return;
      }

      this.isTransactionsLoading = true;

      const params = {
        chainNumber: this.chainNumber,
        ...this.transactionFilters,
        limit: maxTableRows,
        skip,
      };

      api.getTransactionsByType(params)
        .then((res) => {
          this.blockTransactions = {
            totalCount: (res.data && res.data.totalCount) || 0,
            items: (res.data && res.data.items) || [],
            skip,
          };
          this.isTransactionsLoading = false;
        })
        .catch(() => {
          this.isTransactionsLoading = false;
        });
    },
    getLinkToAccount(walletAddress) {
      return getLinkToAccount(walletAddress, this.blockDetails.chainNumber);
    },
    handleCopied(copiedText) {
      // Handle copied event from SearchableTable
      this.copied = copiedText;
      console.log('Copied:', copiedText);
    },
    getTxCreationDateUtc(timestamp) {
      if (!timestamp) {
        return '';
      }
      return `${moment.utc(timestamp).format('YYYY-MM-DD HH:mm:ss')} UTC`;
    },
    modifyMetadata(item) {
      return string.modifyMetadata(item);
    },
    goBack() {
      this.$router.back()
    },
    setFoundResult(data) {
      const page = Number(data?.page) > 0 ? Number(data.page) : 1;
      this.getItem(page);
    },
    getItem(page) {
      const normalizedPage = Number(page) > 0 ? Number(page) : 1;
      const skip = (normalizedPage - 1) * maxTableRows;
      this.fetchTransactions(skip);
    },
     getInitialPage() {
      const skip = this.blockTransactions?.skip
        ?? this.blockTransactions?.meta?.skip
        ?? 0;
      return Math.floor(skip / this.pageSize) + 1;
    },
    getBlockDetails() {
      this.isBlockLoading = true;
      const blockNumber = parseInt(this.blockNumber);

      return api.getBlockByNumber(blockNumber, this.chainNumber)
        .then((res) => {
          this.blockDetails = res.data.result;
          // this.blockDetails = blockDetails ? blockDetails[0] : {};
          this.isBlockLoading = false;

          this.initializeBlockFilters();
          this.fetchTransactions(0);
        })
        .catch(() => {
          this.isBlockLoading = false;
        })
    },
    searchByBlock() {
      // Initialize filters for the block and fetch
      this.initializeBlockFilters();
      this.fetchTransactions(0);
    },
    handleFiltersChanged(filterData) {
      const types = Array.isArray(filterData.type)
        ? filterData.type
        : (filterData.type ? [filterData.type] : []);

      const statuses = Array.isArray(filterData.status)
        ? filterData.status
        : (filterData.status ? [filterData.status] : []);
      const fromAddress = typeof filterData.from === 'string' && filterData.from.trim()
        ? filterData.from.trim()
        : undefined;
      const toAddress = typeof filterData.to === 'string' && filterData.to.trim()
        ? filterData.to.trim()
        : undefined;

      this.transactionFilters = {
        type: types,
        minBlock: filterData.blockMin ?? undefined,
        maxBlock: filterData.blockMax ?? undefined,
        dateFrom: filterData.dateFrom ?? undefined,
        dateTo: filterData.dateTo ?? undefined,
        from: fromAddress,
        to: toAddress,
        status: statuses.length ? statuses : ['valid', 'invalid'],
      };

      this.fetchTransactions(0);
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    setCopied(hash) {
      this.copied = hash;
    },
    getShortenedText(str) {
      return string.getShortenHash(str)
    },
  }
}
</script>
<style scoped>
.icon {
  display: inline-block;
  vertical-align: middle;
}
.icon--plus > path {
  fill: #3D94C3;
  stroke: #3D94C3;
  stroke-width: 0.01;
  stroke-linejoin: round;
}
header, .row {
  display: flex;  /* aligns all child elements (flex items) in a row */
}

.col {
  flex: 1;        /* distributes space on the line equally among items */
  width: calc(100% / 3);
}
.popover__content {
  right: unset;
  left: 10px;
  bottom: 0;
}
.result-row {
  min-height: 54px;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #666666;
}
</style>
